import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation CreateMosaicPageForDev(
    $tenantId: ID!
    $zoneId: ID!
    $input: MosaicPageForDevInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          createPage(input: $input)
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.CreateMosaicPageForDevMutation,
  undefined,
  graphql.schema.CreateMosaicPageForDevMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
